import { ScoreDefinitionDTO } from 'business/models/Models';
import { CustomCheckBox } from 'components/input';
import React from 'react';
import { IStyle } from 'Styles';
import { GeneralObjectType } from '../Contants';
import { changeScoreSelectedItems } from '../utils';

export interface WellScoresProps {
  scoreGroups: GeneralObjectType[];
  allWellsScoresList: GeneralObjectType[];
  allScores: ScoreDefinitionDTO[];
  selectedScoreGroups: GeneralObjectType[];
  lastActionPerformed: {};
  setSelectedScoreGroups: React.Dispatch<React.SetStateAction<GeneralObjectType[]>>;
  scoresSelection: () => void;
}

export const renderScoresInGroups = (
  allScores,
  item,
  allWellsScoresList,
  selectedScoreGroups,
  changeScoreSelectedItems,
  setSelectedScoreGroups,
  scoresSelection,
  lastActionPerformed,
) => {
  return allScores.map(
    (score, i) =>
      score.scoreGroupName === item && (
        <div id={`wellscore-renderscoresingroups-wrapper-${i}`} key={`scCard${i}`} style={styles.spacing}>
          <CustomCheckBox
            id={`wellscore-renderscoresingroups-checkbox-${i}`}
            onChange={() =>
              changeScoreSelectedItems(
                score,
                allWellsScoresList,
                selectedScoreGroups,
                setSelectedScoreGroups,
                scoresSelection,
                lastActionPerformed,
              )
            }
            label={score.scoreName}
            checked={selectedScoreGroups.some(
              (selectedScore) =>
                selectedScore.scoreGroupName === score.scoreGroupName &&
                selectedScore.scoreName === score.scoreName,
            )}
            labelStyle={{ fontFamily: 'Arial', fontWeight: 400, marginLeft: '0.75rem' }}
          />
        </div>
      ),
  );
};

const WellScores = (props) => {
  const {
    scoreGroups,
    allWellsScoresList,
    allScores,
    selectedScoreGroups,
    lastActionPerformed,
    setSelectedScoreGroups,
    scoresSelection,
  } = props;
  const scoresGroupList = scoreGroups.map((item) => (
    <>
      <div id={`wellscores-wellscoregroup-list-${item}`} style={styles.scoreTitle}>{` ${item} - Group `}</div>
      {renderScoresInGroups(
        allScores,
        item,
        allWellsScoresList,
        selectedScoreGroups,
        changeScoreSelectedItems,
        setSelectedScoreGroups,
        scoresSelection,
        lastActionPerformed,
      )}
    </>
  ));

  return <>{scoresGroupList}</>;
};

export const styles: IStyle = {
  scoreTitle: {
    marginLeft: '15px',
    marginTop: '10px',
    maxWidth: 'fit-content',
  },
  spacing: {
    marginTop: '2%',
    marginLeft: '5%',
  },
};
export default WellScores;
